<template>
    <div class="base-service" :class="{'service-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img src="~images/back.png" />
            </div>
            <div class="title">客服中心</div>
        </div>
        <div class="fixed-bottom">
            <div class="tips" v-show="istips">
                <img src="~images/tips.png" />
                <div>温馨提醒：客服只处理平台问题，不可转账，被骗后果自负</div>
                <img class="close" src="~images/close.png" @click="istips = false" />
            </div>
            <div class="quick-box">
                <div v-for="(item, index) in quickList" :key="index">
                    <a class="quick" :href="item.url">
                        <img :src="item.img" />
                        <div class="name">{{item.name}}</div>
                        <div class="btn">{{item.btn}}</div>
                    </a>
                </div>
            </div>
            <div class="problem">
                <div class="line"></div>
                <div>常见问题</div>
            </div>
            <div class="list-box">
                <div class="list" v-for="(item, index) in infoList" :key="index" @click="goDetail(item.name)">
                    <div class="left">
                        <img :src="item.img" />
                        <span>{{item.name}}</span>
                    </div>
                    <div class="right">
                        <img src="~images/move.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseService',
        data () {
            return {
                infoList: [
                    {
                        img: require('images/service_1.png'),
                        name: '充值问题'
                    },
                    {
                        img: require('images/service_2.png'),
                        name: '返利问题'
                    },
                    {
                        img: require('images/service_3.png'),
                        name: '会员问题'
                    },
                    {
                        img: require('images/service_4.png'),
                        name: '货币问题'
                    },
                    {
                        img: require('images/service_5.png'),
                        name: '交易问题'
                    },
                    {
                        img: require('images/service_6.png'),
                        name: '游戏问题'
                    },
                    {
                        img: require('images/service_7.png'),
                        name: '账户安全'
                    }
                ],
                quickList: [
                    {
                        img: require('images/service_qq.png'),
                        name: 'QQ客服',
                        btn: '联系我',
                        url: ''
                    },
                    {
                        img: require('images/service_group.png'),
                        name: '玩家QQ群',
                        btn: '进群聊',
                        url: ''
                    },
                    {
                        img: require('images/service_wx.png'),
                        name: '微信公众号',
                        btn: '关注我',
                        url: ''
                    }
                ],
                istips: true,
                accountData: {}
            }
        },
        methods: {
            // 获取客服信息
            getService () {
                let options = {
                    channel: this.accountData.channel ? this.accountData.channel : 1
                }
                options.sign = this.util.getSign(options)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=customer_service', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        if (res.data.data) {
                            let data = res.data.data
                            if (/(Android)/i.test(window.navigator.userAgent)) {
                                data.shouyou_qq.href = 'mqqwpa://im/chat?chat_type=wpa&uin='+ data.shouyou_qq.number +'&version=1&src_type=web&web_src=http:://wpa.b.qq.com'
                                data.shouyou_group.href = 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3D'+data.shouyou_group.link
                            } else if(/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)){
                                data.shouyou_qq.href = 'mqqwpa://im/chat?chat_type=wpa&uin='+ data.shouyou_qq.number +'&version=1&src_type=web&web_src=http:://wpa.b.qq.com'
                                data.shouyou_group.href = 'mqqapi://card/show_pslcard?src_type=internal&version=1&uin='+data.shouyou_group.number+'&key='+data.shouyou_group.link+ '&card_type=group&source=external'
                            } else {
                                data.shouyou_qq.href = 'http://wpa.qq.com/msgrd?v=3&uin='+ data.shouyou_qq.number +'&site=oicqzone.com&menu=yes'
                                data.shouyou_group.href = this.htmlspecialchars_decode(data.shouyou_group.weblink)
                            }
                            this.quickList[0].url = data.shouyou_qq.href
                            this.quickList[1].url = data.shouyou_group.href
                            this.quickList[2].url = res.data.data.wechat.id
                        }
                    }
                })
            },
            htmlspecialchars_decode (str) {
                str = str.replace(/&amp;/g, '&')
                str = str.replace(/&lt;/g, '<')
                str = str.replace(/&gt;/g, '>')
                str = str.replace(/&quot;/g, "''")
                str = str.replace(/&#039;/g, "'")
                return str
            },
            // 跳转
            goDetail(name){
                console.log("点击跳转",name)
                // /base-problem?name=返利问题
                this.$router.push('/base-problem?name='+ name)
                console.log("跳转成功")
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.getService()
        },
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-service {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
        }
        .fixed-bottom {
            flex: 1;
            overflow-y: scroll;
        }
        .tips {
            height: 60px;
            color: $color;
            font-size: 30px;
            background: rgba($color, 0.1);
            overflow: hidden;
            display: flex;
            align-items: center;
            position: relative;
            img {
                width: 60px;
                height: 60px;
            }
            .close {
                position: absolute;
                right: 0;
            }
        }
        .quick-box {
            overflow: hidden;
            margin: 30px 45px 0;
            display: flex;
            justify-content: space-between;
            .quick {
                width: 300px;
                height: 360px;
                background: rgba(255, 255, 255, 0.2);
                box-shadow: 1px 6px 10px 0px rgba(0, 0, 0, 0.06);
                border-radius: 18px;
                text-decoration: none;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                    width: 90px;
                    height: 90px;
                }
                .name {
                    color: #fff;
                    font-size: 36px;
                    line-height: 108px;
                }
                .btn {
                    width: 168px;
                    height: 72px;
                    font-size: 33px;
                    color: $color;
                    border: 3px solid $color;
                    border-radius: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .problem {
            font-size: 45px;
            margin: 60px 60px 0;
            display: flex;
            align-items: center;
            .line {
                width: 12px;
                height: 24px;
                background: $color;
                margin: 5px 19px 0 0;
            }
        }
        .list-box {
            margin: 45px 60px 60px;
            overflow: hidden;
            .list {
                height: 120px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                .left {
                    height: 100%;
                    font-size: 42px;
                    float: left;
                    display: flex;
                    align-items: center;
                    img {
                        width: 48px;
                        height: 48px;
                        margin-right: 40px;
                    }
                }
                .right {
                    height: 100%;
                    font-size: 36px;
                    float: right;
                    display: flex;
                    align-items: center;
                    img {
                        width: 36px;
                        height: 36px;
                        margin-left: 30px;
                    }
                }
            }
            .list:first-child {
                border-radius: 18px 18px 0 0;
            }
            .list:last-child {
                border-radius: 0 0 18px 18px;
                border-bottom: 0;
            }
        }
    }
    // 竖屏css
    .service-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                img {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
        }
        .tips {
            height: auto;
            padding: 20px;
            font-size: 42px;
            overflow: hidden;
            img {
                width: 90px;
                height: 90px;
            }
        }
        .quick-box {
            margin: 60px 90px 0;
            .quick {
                width: 420px;
                height: 490px;
                border-radius: 32px;
                img {
                    width: 120px;
                    height: 120px;
                }
                .name {
                    font-size: 55px;
                    line-height: 140px;
                }
                .btn {
                    width: 230px;
                    height: 100px;
                    font-size: 50px;
                    border: 3px solid $color;
                    border-radius: 65px;
                }
            }
        }
        .problem {
            font-size: 81px;
            margin: 90px 90px 0;
            .line {
                width: 21px;
                height: 43px;
                margin: 9px 34px 0 0;
            }
        }
        .list-box {
            margin: 60px 90px 90px;
            .list {
                height: 200px;
                padding: 0 60px;
                .left {
                    height: 100%;
                    font-size: 70px;
                    img {
                        width: 87px;
                        height: 87px;
                        margin-right: 60px;
                    }
                }
                .right {
                    height: 100%;
                    font-size: 60px;
                    img {
                        width: 60px;
                        height: 60px;
                        margin-left: 54px;
                    }
                }
            }
            .list:first-child {
                border-radius: 32px 32px 0 0;
            }
            .list:last-child {
                border-radius: 0 0 32px 32px;
                border-bottom: 0;
            }
        }
    }
</style>